import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {
    getLists,
    isErrorResponse,
    getListsDetail,
    ListItem,
    SNSDataList,
    DeleteAccountRequest,
} from "../../util/api";
import {ListComponent} from "../../components/List";
import {SetSNSLists} from "../../actions";
import {HeaderContainer} from "../Header";

import styles from "./css/dock.module.scss";
import {AddListModal} from "../AddListModal";
import {AddAccountModal} from "../AddAccountModal";
import firebase from "firebase";
import {DeleteListModal} from "../DeleteListModal";
import {AccountListDialog} from "../../components/AccountListDialog";
import {DeleteAccountDialog} from "../DeleteAccountDialog";

export const DockContainer: React.FC = (props: any) => {
    const listSelector = (state: any) => state.snsLists;

    const snsLists = useSelector(listSelector);

    const dispatch = useDispatch();
    useEffect(() => {
        firebase.auth().onAuthStateChanged(async () => {
            const list = await getLists();
            if (isErrorResponse(list)) {
                alert("リストの取得に失敗しました。");
                return;
            }
            let snsList: Array<SNSDataList> = [];

            if (
                localStorage.getItem("lastUpdatedAt") == null ||
                list.length !== snsLists.length ||
                moment(
                    localStorage.getItem("lastUpdatedAt") || moment().toString()
                )
                    .add(10, "m")
                    .isBefore(moment())
            ) {
                await Promise.all(
                    list.map(async (l: ListItem) => {
                        await getListsDetail(l.id).then((listDetail) => {
                            if (isErrorResponse(listDetail)) {
                                alert("リストの取得に失敗しました。");
                                return;
                            }
                            listDetail.name = l.name;
                            snsList.push(listDetail);
                        });
                    })
                ).then(() => {
                    snsList.sort((a, b) => a.id - b.id);
                    dispatch(SetSNSLists(snsList));
                    localStorage.setItem("lastUpdatedAt", moment().toString());
                });
            }
        });
        // eslint-disable-next-line
    }, [dispatch]);

    const [open, setOpen] = useState(false);
    const [addAccountOpen, setAddAccountOpen] = useState(false);
    const [deleteListOpen, setDeleteListOpen] = useState(false);
    const [accountListOpen, setAccountListOpen] = useState(false);
    const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
    const [
        deleteAccountRequest,
        setDeleteAccountRequest,
    ] = useState<DeleteAccountRequest | null>(null);
    const [selectedListId, setSelectedListId] = useState(0);

    return (
        <>
            <HeaderContainer setOpen={setOpen} />
            <div className={styles.wrap}>
                <ListComponent
                    lists={snsLists}
                    setOpenModal={setOpen}
                    setOpenAddAccount={setAddAccountOpen}
                    setOpenDeleteList={setDeleteListOpen}
                    setOpenAccountList={setAccountListOpen}
                    setSelectedList={setSelectedListId}
                />
            </div>
            <AddListModal isOpen={open} setOpen={setOpen} />
            <AddAccountModal
                isOpen={addAccountOpen}
                setOpen={setAddAccountOpen}
                selectedList={selectedListId}
            />
            <DeleteListModal
                isOpen={deleteListOpen}
                setOpen={setDeleteListOpen}
                selectedList={selectedListId}
            />
            <AccountListDialog
                isOpen={accountListOpen}
                setOpen={setAccountListOpen}
                setAddAccountOpen={setAddAccountOpen}
                setDeleteAccountOpen={setDeleteAccountOpen}
                setDeleteAccountRequest={setDeleteAccountRequest}
                list={snsLists.find(
                    (l: SNSDataList) => l.id === selectedListId
                )}
            />
            <DeleteAccountDialog
                isOpen={deleteAccountOpen}
                setOpen={setDeleteAccountOpen}
                selectedList={selectedListId}
                account={deleteAccountRequest}
                snsLists={snsLists}
            />
        </>
    );
};
